<div class="l-main" role="main">
	<div class="l-container">

		<div class="l-content">
			<div class="panel-pane bg-transparent align-center">
				<ul class="list--pipe">
					<li><a href="">Visit the UC Davis directory</a></li>
				</ul>
			</div>

			<div class="panel-pane box">
			<div>{{updateHeader()}}</div>
				<!-- ********** Main content ********** -->
				<div id="main_section" role="main">
					<!-- Center column (primary content) -->
					<div id="center_column">
						<div id="center_column_inner_wrap">

							<!--  <br /> -->
							<div class="quick-summary align-right">
								<h2 class="quick-summary__title">Supplementary Information</h2>
								<ul class="quick-summary__list">
									<li><nav><a routerLink="/help">People listing help </a></nav></li>
									<li><a target="_blank" href="assets/pdf/CampusAbbreviations.pdf">Building, department, office, and title abbreviations
									   <br>(CampusAbbreviations)</a></li>	
									<li><a href="https://org.ucdavis.edu/odr"> Update my directory listing </a></li>
									<li><a href="https://org.ucdavis.edu/wmnotify"> Update my WarnMe information </a></li>
									<li><nav><a routerLink="/how-to-search-people">How to search people</a></nav></li>
									<li><nav><a routerLink="/how-to-search-departments">How to search departments </a></nav></li>

								</ul>

							</div>

							<div>
								<h2 class="first">The UC Davis Online Directory</h2>
								<p>
									The UC Davis Online Directory contains public contact
									information for individuals and departments on the UC Davis
									campus and at UC Davis Health in Sacramento. Directory
									information is publicly searchable from the main <a
										href="https://www.ucdavis.edu"><font size="3" color="navy">UC
											Davis website</font> </a> and is also shared by the campus operator via
									(530) 752&#45;1011 or &quot;0&quot; from a Davis campus
									telephone.
								</p>

								<p>UC Davis faculty and staff are encouraged to update their
									public directory information, and if preferred, limit search to
									UC Davis affiliated computers only.</p>
								
								<h2 class="first">Directory Approvers</h2>
								<p>The individual and department contact information in the
									online directory is maintained by directory approvers. Updates
									to contact information for individuals may be initiated by each
									individual, but it must be approved by department and
									campus&#45;wide directory approvers before becoming available
									to the public. Updates to department contact information are
									submitted by each department&#39;s directory approver to
									Directory Services in IET - Communications Resources for campus
									departments or the Telecommunications Office at the UC Davis
									Health System for Sacramento campus departments.</p>

								<!--<p><strong>Privacy Notice:</strong> This campus directory is the property of <a href="https://www.ucdavis.edu"><font size="3" color="navy">University of California, Davis.</font> </a> To protect the privacy of individuals listed herein, in accordance with the State of California Information Practices Act, this directory may not be used, rented, distributed, or sold for commercial purposes.</p>-->

							</div>
						</div>
					</div>
					<!-- End center column -->
				</div>
				<!-- ********** End main content ********** -->

			</div>
		</div>
		<!--end .l-content-->

	</div>

</div>
<!--End role=main-->
<p class="privacy">
	<strong>Privacy Notice:</strong> This campus directory is the property
	of <a href="https://www.ucdavis.edu"><font size="3" color="navy">University
			of California, Davis.</font> </a> To protect the privacy of individuals listed
	herein, in accordance with the State of California Information
	Practices Act, this directory may not be used, rented, distributed, or
	sold for commercial purposes.
</p>


